import { getLastSearchData } from '@tools/last-search';

export const renderHomeLastSearch = (): string | null => {
  const mount = document.getElementById('last-search-teaser');
  if (!mount) {
    return null;
  }

  const data = getLastSearchData();
  if (!data) {
    mount.classList.add('hidden');
    return null;
  }

  const textTarget = mount.querySelector('[data-last-search-text]') as HTMLElement | null;
  if (!textTarget) {
    mount.textContent = data.fullText;
    mount.classList.remove('hidden');

    return data.fullText;
  }

  if (!data.url) {
    textTarget.textContent = data.labelText;
    mount.classList.remove('hidden');

    return data.fullText;
  }

  const link = document.createElement('a');

  link.href = data.url as string;
  link.className = 'last-search__link';
  link.textContent = data.labelText;

  textTarget.textContent = '';
  textTarget.appendChild(link);

  mount.classList.remove('hidden');

  return data.fullText;
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderHomeLastSearch);
} else {
  renderHomeLastSearch();
}
